import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// @ts-ignore: allow side-effect CSS import without module declarations
import "./CarOrder.css";
// @ts-ignore: allow side-effect CSS import without module declarations
import "react-toastify/dist/ReactToastify.css";
import { useCarOrders } from "./hooks/useCarOrder";
import { useExportCarOrders } from "./hooks/useExportCarOrders";
import CarOrderTable from "./components/CarOrderTable";
import { CircularProgress } from "@mui/material";
import CarOrderControls from "./components/CarOrderControls";
import { PageTitle } from "src/shared/PageTitle";
import { ToastContainer } from "react-toastify";
import { useUser } from "src/shared/context/UserContext";

const CarOrderList: React.FC = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [filters, setFilters] = useState({
    filter: "Today",
    selectedDate: "",
    selectedDate2: "",
    exportFormat: "",
  });
  const [page, setPage] = useState(0);
  const { userConfigration } = useUser();
  const [rowsPerPage, setRowsPerPage] = useState(userConfigration?.tableDefaultSize || 10);

  const { orders, loading, error, totalCount } = useCarOrders(page, rowsPerPage, filters.filter, filters.selectedDate, filters.selectedDate2, searchQuery);
  const paginationData = {
    totalRecords: totalCount,
  };
  const { handleDownload, loadingExport } = useExportCarOrders(orders);

  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const handleChangePage = (_: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCustomerClick = (orderId: string | number) => {
    navigate(`/v1/car-order-details/${orderId}`);
  };

  const handleFilterChange = (filter: string) => {
    setFilters((prev) => ({
      ...prev,
      filter,
      selectedDate: filter !== "CustomizeDate" ? "" : prev.selectedDate,
      selectedDate2: filter !== "CustomizeDate" ? "" : prev.selectedDate2,
    }));
  };

  const handleDateChange = (date: string) => {
    setFilters((prev) => ({ ...prev, selectedDate: date }));
  };

  const handleDate2Change = (date: string) => {
    setFilters((prev) => ({ ...prev, selectedDate2: date }));
  };

  return (
    <div>
      <div className="car-orders-table-container">
        <PageTitle title="Orders" />
        <CarOrderControls
          filter={filters.filter}
          setFilter={handleFilterChange}
          selectedDate={filters.selectedDate}
          setSelectedDate={handleDateChange}
          selectedDate2={filters.selectedDate2}
          setSelectedDate2={handleDate2Change}
          searchQuery={searchQuery}
          handleSearchChange={onSearchChange}
          exportFormat={filters.exportFormat}
          handleDownload={handleDownload}
          loadingExport={loadingExport}
        />

        <div className="orders-customer-table">
          {loading ? (
            <div className="orders-loading">
              <CircularProgress />
            </div>
          ) : error ? (
            <div className="orders-error">{error}</div>
          ) : (
            <CarOrderTable
              orders={orders}
              onRowClick={handleCustomerClick}
              page={page}
              rowsPerPage={rowsPerPage}
              paginationData={paginationData}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          )}
        </div>
        <ToastContainer autoClose={1000} />
      </div>
    </div>
  );
};

export default CarOrderList;
